import { gql, useLazyQuery } from '@apollo/client';
export interface JunoTmsIssuesVars {
    collectionIdentifier: string;
    startTime: string;
    endTime: string;
    issuePrefix: string;
}

export interface JunoTmsIssue {
    issueType: string;
    timestamp: Date;
    details: string;
    isResolved: string;
    supportSOP: string;
    serviceSOP: string;
}

export interface JunoTmsIssuesData {

    getJunoTmsIssuesArchive: JunoTmsIssue[];
}
const GQL_COLLECTION_TMS_ARCHIVE_ISSUES = gql`
  query getCollectionTMSIssuesArchive(
    $collectionIdentifier: String!
    $startTime: String!
    $endTime: String!
    $issuePrefix: String
  ) {
    getJunoTmsIssuesArchive(
      collectionIdentifier: $collectionIdentifier
      startTime: $startTime
      endTime: $endTime
      issuePrefix: $issuePrefix
    ){
        issueType
        timestamp
        details
        isResolved
        supportSOP
        serviceSOP
    }
  }
`;

export const useJunoTmsQueryArchive = () => {
    return useLazyQuery<JunoTmsIssuesData, JunoTmsIssuesVars>(GQL_COLLECTION_TMS_ARCHIVE_ISSUES, {
        errorPolicy: 'all',
    });
};
